import React, { useEffect } from 'react';

interface IProps {
  ref: React.MutableRefObject<HTMLElement>;
  hash: string;
}

let id: number | NodeJS.Timeout;
export const scrollTo = (
  $el: HTMLElement,
  offset = 0,
  callback: (() => void) | null = null,
  from = 'top',
  behavior: ScrollBehavior = 'smooth'
) => {
  if (!$el) return;

  clearInterval(id);

  // eslint-disable-next-line @typescript-eslint/ban-ts-comment
  // @ts-ignore
  let position = window.scrollY + $el.getBoundingClientRect()[from] + offset;
  position = Math.round(position);

  window.scrollTo({
    top: position,
    behavior: behavior,
  });

  if (callback) {
    id = setInterval(() => {
      if (position == window.scrollY) {
        clearInterval(id);
        callback();
      }
    }, 25);
  }
};

export const useHash = ({ ref, hash }: IProps) => {
  useEffect(() => {
    if (hash != location.hash) return;

    const $el = ref.current;

    if (!$el) return;

    scrollTo($el);
    // eslint-disable-next-line react-hooks/exhaustive-deps
  }, []);
};
